<div style="width: 100px; height: 100px; position: absolute; top: 0; bottom: 0; left: 0; right: 0; margin: auto" *ngIf="preloaderImageUrl">
  <p align="center" class="search_img">
    <img src="{{ preloaderImageUrl }}" alt="Cargando" />
  </p>
</div>
